import React, { useState } from 'react';

const defaultValue = {
  vendas: [],
  vendaAtual: {},
  idVendaAtual: '',
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  modal: '',
  search: '',
  isClone: false,
  templateMailOrcamento: '',
  visualizarPendencias: false,
  pendencias: [],
  email: '',
  filtroAvancado: {},
  limitarCategorias: false,
  motivoVenda: 'VENDA_PADRAO',
  page: 0,
  size: 15,
  sort: 'data,DESC',
};

export const VendaContext = React.createContext({});

export const VendaProvider = (props) => {
  return (
    <VendaContext.Provider
      value={{
        vendas: useState(defaultValue.vendas),
        vendaAtual: useState(defaultValue.vendaAtual),
        idVendaAtual: useState(defaultValue.idVendaAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        isClone: useState(defaultValue.isClone),
        templateMailOrcamento: useState(defaultValue.templateMailOrcamento),
        visualizarPendencias: useState(defaultValue.visualizarPendencias),
        pendencias: useState(defaultValue.pendencias),
        email: useState(defaultValue.email),
        filtroAvancado: useState(defaultValue.filtroAvancado),
        limitarCategorias: useState(defaultValue.limitarCategorias),
        motivoVenda: useState(defaultValue.motivoVenda),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
      }}
    >
      {props.children}
    </VendaContext.Provider>
  );
};

export const VendaConsumer = VendaContext.Consumer;
